import ActionConstants from '../constants';

const initialState = {
  // Get Convenience Fees
  getConvenienceFeesState: {
    loading: false,
    success: false,
    failure: false,
    data: null,
    error: null,
  },

  // Get Convenience Fee Detail
  getConvenienceFeeDetailState: {
    loading: false,
    success: false,
    failure: false,
    data: null,
    error: null,
  },

  // Get Feature Fees
  getFeatureFeesState: {
    loading: false,
    success: false,
    failure: false,
    data: null,
    error: null,
  },

  // Get Merchant Mappings
  getMerchantMappingsState: {
    loading: false,
    success: false,
    failure: false,
    data: null,
    error: null,
  },

  // Get Merchant Fee Mappings (reverse lookup)
  getMerchantFeeMappingsState: {
    loading: false,
    success: false,
    failure: false,
    data: null,
    error: null,
  },

  // Get Payment Modes
  getPaymentModesState: {
    loading: false,
    success: false,
    failure: false,
    data: null,
    error: null,
  },

  // Get Network Types
  getNetworkTypesState: {
    loading: false,
    success: false,
    failure: false,
    data: null,
    error: null,
  },

  // Submit Change Request
  submitChangeRequestState: {
    loading: false,
    success: false,
    failure: false,
    data: null,
    error: null,
  },

  // Get Change Requests
  getChangeRequestsState: {
    loading: false,
    success: false,
    failure: false,
    data: null,
    error: null,
  },

  // Get Change Request Detail
  getChangeRequestDetailState: {
    loading: false,
    success: false,
    failure: false,
    data: null,
    error: null,
  },

  // Approve Change Request
  approveChangeRequestState: {
    loading: false,
    success: false,
    failure: false,
    data: null,
    error: null,
  },

  // Reject Change Request
  rejectChangeRequestState: {
    loading: false,
    success: false,
    failure: false,
    data: null,
    error: null,
  },

  // Get Execution Status
  getExecutionStatusState: {
    loading: false,
    success: false,
    failure: false,
    data: null,
    error: null,
  },
};

const feeConfigurationReducer = (state = initialState, action: any) => {
  switch (action.type) {
    // Get Convenience Fees
    case ActionConstants.GET_FEE_CONFIG_CONVENIENCE_FEES_REQUEST:
      return { ...state, getConvenienceFeesState: { ...state.getConvenienceFeesState, loading: true, success: false, failure: false, error: null } };
    case ActionConstants.GET_FEE_CONFIG_CONVENIENCE_FEES_SUCCESS:
      return { ...state, getConvenienceFeesState: { ...state.getConvenienceFeesState, loading: false, success: true, failure: false, data: action.payload?.body, error: null } };
    case ActionConstants.GET_FEE_CONFIG_CONVENIENCE_FEES_FAILURE:
      return { ...state, getConvenienceFeesState: { ...state.getConvenienceFeesState, loading: false, success: false, failure: true, data: null, error: action.payload?.body } };
    case ActionConstants.GET_FEE_CONFIG_CONVENIENCE_FEES_CLEAR:
      return { ...state, getConvenienceFeesState: { ...initialState.getConvenienceFeesState } };

    // Get Convenience Fee Detail
    case ActionConstants.GET_FEE_CONFIG_CONVENIENCE_FEE_DETAIL_REQUEST:
      return { ...state, getConvenienceFeeDetailState: { ...state.getConvenienceFeeDetailState, loading: true, success: false, failure: false, error: null } };
    case ActionConstants.GET_FEE_CONFIG_CONVENIENCE_FEE_DETAIL_SUCCESS:
      return { ...state, getConvenienceFeeDetailState: { ...state.getConvenienceFeeDetailState, loading: false, success: true, failure: false, data: action.payload?.body, error: null } };
    case ActionConstants.GET_FEE_CONFIG_CONVENIENCE_FEE_DETAIL_FAILURE:
      return { ...state, getConvenienceFeeDetailState: { ...state.getConvenienceFeeDetailState, loading: false, success: false, failure: true, data: null, error: action.payload?.body } };
    case ActionConstants.GET_FEE_CONFIG_CONVENIENCE_FEE_DETAIL_CLEAR:
      return { ...state, getConvenienceFeeDetailState: { ...initialState.getConvenienceFeeDetailState } };

    // Get Feature Fees
    case ActionConstants.GET_FEE_CONFIG_FEATURE_FEES_REQUEST:
      return { ...state, getFeatureFeesState: { ...state.getFeatureFeesState, loading: true, success: false, failure: false, error: null } };
    case ActionConstants.GET_FEE_CONFIG_FEATURE_FEES_SUCCESS:
      return { ...state, getFeatureFeesState: { ...state.getFeatureFeesState, loading: false, success: true, failure: false, data: action.payload?.body, error: null } };
    case ActionConstants.GET_FEE_CONFIG_FEATURE_FEES_FAILURE:
      return { ...state, getFeatureFeesState: { ...state.getFeatureFeesState, loading: false, success: false, failure: true, data: null, error: action.payload?.body } };
    case ActionConstants.GET_FEE_CONFIG_FEATURE_FEES_CLEAR:
      return { ...state, getFeatureFeesState: { ...initialState.getFeatureFeesState } };

    // Get Merchant Mappings
    case ActionConstants.GET_FEE_CONFIG_MERCHANT_MAPPINGS_REQUEST:
      return { ...state, getMerchantMappingsState: { ...state.getMerchantMappingsState, loading: true, success: false, failure: false, error: null } };
    case ActionConstants.GET_FEE_CONFIG_MERCHANT_MAPPINGS_SUCCESS:
      return { ...state, getMerchantMappingsState: { ...state.getMerchantMappingsState, loading: false, success: true, failure: false, data: action.payload?.body, error: null } };
    case ActionConstants.GET_FEE_CONFIG_MERCHANT_MAPPINGS_FAILURE:
      return { ...state, getMerchantMappingsState: { ...state.getMerchantMappingsState, loading: false, success: false, failure: true, data: null, error: action.payload?.body } };
    case ActionConstants.GET_FEE_CONFIG_MERCHANT_MAPPINGS_CLEAR:
      return { ...state, getMerchantMappingsState: { ...initialState.getMerchantMappingsState } };

    // Get Merchant Fee Mappings (reverse lookup)
    case ActionConstants.GET_FEE_CONFIG_MERCHANT_FEE_MAPPINGS_REQUEST:
      return { ...state, getMerchantFeeMappingsState: { ...state.getMerchantFeeMappingsState, loading: true, success: false, failure: false, error: null } };
    case ActionConstants.GET_FEE_CONFIG_MERCHANT_FEE_MAPPINGS_SUCCESS:
      return { ...state, getMerchantFeeMappingsState: { ...state.getMerchantFeeMappingsState, loading: false, success: true, failure: false, data: action.payload?.body, error: null } };
    case ActionConstants.GET_FEE_CONFIG_MERCHANT_FEE_MAPPINGS_FAILURE:
      return { ...state, getMerchantFeeMappingsState: { ...state.getMerchantFeeMappingsState, loading: false, success: false, failure: true, data: null, error: action.payload?.body } };
    case ActionConstants.GET_FEE_CONFIG_MERCHANT_FEE_MAPPINGS_CLEAR:
      return { ...state, getMerchantFeeMappingsState: { ...initialState.getMerchantFeeMappingsState } };

    // Get Payment Modes
    case ActionConstants.GET_FEE_CONFIG_PAYMENT_MODES_REQUEST:
      return { ...state, getPaymentModesState: { ...state.getPaymentModesState, loading: true, success: false, failure: false, error: null } };
    case ActionConstants.GET_FEE_CONFIG_PAYMENT_MODES_SUCCESS:
      return { ...state, getPaymentModesState: { ...state.getPaymentModesState, loading: false, success: true, failure: false, data: action.payload?.body, error: null } };
    case ActionConstants.GET_FEE_CONFIG_PAYMENT_MODES_FAILURE:
      return { ...state, getPaymentModesState: { ...state.getPaymentModesState, loading: false, success: false, failure: true, data: null, error: action.payload?.body } };
    case ActionConstants.GET_FEE_CONFIG_PAYMENT_MODES_CLEAR:
      return { ...state, getPaymentModesState: { ...initialState.getPaymentModesState } };

    // Get Network Types
    case ActionConstants.GET_FEE_CONFIG_NETWORK_TYPES_REQUEST:
      return { ...state, getNetworkTypesState: { ...state.getNetworkTypesState, loading: true, success: false, failure: false, error: null } };
    case ActionConstants.GET_FEE_CONFIG_NETWORK_TYPES_SUCCESS:
      return { ...state, getNetworkTypesState: { ...state.getNetworkTypesState, loading: false, success: true, failure: false, data: action.payload?.body, error: null } };
    case ActionConstants.GET_FEE_CONFIG_NETWORK_TYPES_FAILURE:
      return { ...state, getNetworkTypesState: { ...state.getNetworkTypesState, loading: false, success: false, failure: true, data: null, error: action.payload?.body } };
    case ActionConstants.GET_FEE_CONFIG_NETWORK_TYPES_CLEAR:
      return { ...state, getNetworkTypesState: { ...initialState.getNetworkTypesState } };

    // Submit Change Request
    case ActionConstants.SUBMIT_FEE_CONFIG_CHANGE_REQUEST_REQUEST:
      return { ...state, submitChangeRequestState: { ...state.submitChangeRequestState, loading: true, success: false, failure: false, error: null } };
    case ActionConstants.SUBMIT_FEE_CONFIG_CHANGE_REQUEST_SUCCESS:
      return { ...state, submitChangeRequestState: { ...state.submitChangeRequestState, loading: false, success: true, failure: false, data: action.payload?.body, error: null } };
    case ActionConstants.SUBMIT_FEE_CONFIG_CHANGE_REQUEST_FAILURE:
      return { ...state, submitChangeRequestState: { ...state.submitChangeRequestState, loading: false, success: false, failure: true, data: null, error: action.payload?.body } };
    case ActionConstants.SUBMIT_FEE_CONFIG_CHANGE_REQUEST_CLEAR:
      return { ...state, submitChangeRequestState: { ...initialState.submitChangeRequestState } };

    // Get Change Requests
    case ActionConstants.GET_FEE_CONFIG_CHANGE_REQUESTS_REQUEST:
      return { ...state, getChangeRequestsState: { ...state.getChangeRequestsState, loading: true, success: false, failure: false, error: null } };
    case ActionConstants.GET_FEE_CONFIG_CHANGE_REQUESTS_SUCCESS:
      return { ...state, getChangeRequestsState: { ...state.getChangeRequestsState, loading: false, success: true, failure: false, data: action.payload?.body, error: null } };
    case ActionConstants.GET_FEE_CONFIG_CHANGE_REQUESTS_FAILURE:
      return { ...state, getChangeRequestsState: { ...state.getChangeRequestsState, loading: false, success: false, failure: true, data: null, error: action.payload?.body } };
    case ActionConstants.GET_FEE_CONFIG_CHANGE_REQUESTS_CLEAR:
      return { ...state, getChangeRequestsState: { ...initialState.getChangeRequestsState } };

    // Get Change Request Detail
    case ActionConstants.GET_FEE_CONFIG_CHANGE_REQUEST_DETAIL_REQUEST:
      return { ...state, getChangeRequestDetailState: { ...state.getChangeRequestDetailState, loading: true, success: false, failure: false, error: null } };
    case ActionConstants.GET_FEE_CONFIG_CHANGE_REQUEST_DETAIL_SUCCESS:
      return { ...state, getChangeRequestDetailState: { ...state.getChangeRequestDetailState, loading: false, success: true, failure: false, data: action.payload?.body, error: null } };
    case ActionConstants.GET_FEE_CONFIG_CHANGE_REQUEST_DETAIL_FAILURE:
      return { ...state, getChangeRequestDetailState: { ...state.getChangeRequestDetailState, loading: false, success: false, failure: true, data: null, error: action.payload?.body } };
    case ActionConstants.GET_FEE_CONFIG_CHANGE_REQUEST_DETAIL_CLEAR:
      return { ...state, getChangeRequestDetailState: { ...initialState.getChangeRequestDetailState } };

    // Approve Change Request
    case ActionConstants.APPROVE_FEE_CONFIG_CHANGE_REQUEST_REQUEST:
      return { ...state, approveChangeRequestState: { ...state.approveChangeRequestState, loading: true, success: false, failure: false, error: null } };
    case ActionConstants.APPROVE_FEE_CONFIG_CHANGE_REQUEST_SUCCESS:
      return { ...state, approveChangeRequestState: { ...state.approveChangeRequestState, loading: false, success: true, failure: false, data: action.payload?.body, error: null } };
    case ActionConstants.APPROVE_FEE_CONFIG_CHANGE_REQUEST_FAILURE:
      return { ...state, approveChangeRequestState: { ...state.approveChangeRequestState, loading: false, success: false, failure: true, data: null, error: action.payload?.body } };
    case ActionConstants.APPROVE_FEE_CONFIG_CHANGE_REQUEST_CLEAR:
      return { ...state, approveChangeRequestState: { ...initialState.approveChangeRequestState } };

    // Reject Change Request
    case ActionConstants.REJECT_FEE_CONFIG_CHANGE_REQUEST_REQUEST:
      return { ...state, rejectChangeRequestState: { ...state.rejectChangeRequestState, loading: true, success: false, failure: false, error: null } };
    case ActionConstants.REJECT_FEE_CONFIG_CHANGE_REQUEST_SUCCESS:
      return { ...state, rejectChangeRequestState: { ...state.rejectChangeRequestState, loading: false, success: true, failure: false, data: action.payload?.body, error: null } };
    case ActionConstants.REJECT_FEE_CONFIG_CHANGE_REQUEST_FAILURE:
      return { ...state, rejectChangeRequestState: { ...state.rejectChangeRequestState, loading: false, success: false, failure: true, data: null, error: action.payload?.body } };
    case ActionConstants.REJECT_FEE_CONFIG_CHANGE_REQUEST_CLEAR:
      return { ...state, rejectChangeRequestState: { ...initialState.rejectChangeRequestState } };

    // Get Execution Status
    case ActionConstants.GET_FEE_CONFIG_EXECUTION_STATUS_REQUEST:
      return { ...state, getExecutionStatusState: { ...state.getExecutionStatusState, loading: true, success: false, failure: false, error: null } };
    case ActionConstants.GET_FEE_CONFIG_EXECUTION_STATUS_SUCCESS:
      return { ...state, getExecutionStatusState: { ...state.getExecutionStatusState, loading: false, success: true, failure: false, data: action.payload?.body, error: null } };
    case ActionConstants.GET_FEE_CONFIG_EXECUTION_STATUS_FAILURE:
      return { ...state, getExecutionStatusState: { ...state.getExecutionStatusState, loading: false, success: false, failure: true, data: null, error: action.payload?.body } };
    case ActionConstants.GET_FEE_CONFIG_EXECUTION_STATUS_CLEAR:
      return { ...state, getExecutionStatusState: { ...initialState.getExecutionStatusState } };

    default:
      return state;
  }
};

export default feeConfigurationReducer;
